"use strict";
/*
 * CODEX-MODIFIED: the contents of this file were written by a human and modified after the fact by a Codex agent.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startApplication = void 0;
const must_go_faster_1 = require("./must-go-faster");
const dom_1 = require("./dom");
const constants_1 = require("./constants");
const startup_1 = require("./startup");
function initializeApplication() {
    document.querySelector('#white-clock').textContent =
        constants_1.GAME_CLOCK_DURATION.toString();
    document.querySelector('#black-clock').textContent =
        constants_1.GAME_CLOCK_DURATION.toString();
    try {
        const mustGoFaster = new must_go_faster_1.MustGoFaster();
        document
            .querySelector('#cancel-button')
            .addEventListener('click', function () {
            mustGoFaster.cancelPendingGame();
        });
        const playerTypeButton = new dom_1.PlayerTypeElement();
        playerTypeButton.element.addEventListener('click', function ({ target }) {
            switch (target === null || target === void 0 ? void 0 : target.id) {
                case 'player-type-computer':
                    playerTypeButton.setSelection('computer');
                    mustGoFaster.setOpponentType('computer');
                    break;
                case 'player-type-human':
                    playerTypeButton.setSelection('human');
                    mustGoFaster.setOpponentType('human');
                    break;
                default:
                    break;
            }
        });
    }
    catch (error) {
        console.error('Failed to initialize: ', error);
    }
}
function startApplication() {
    return __awaiter(this, void 0, void 0, function* () {
        const startupState = document.querySelector('#startup-state');
        const spinner = document.querySelector('#startup-spinner');
        const error = document.querySelector('#startup-error');
        const appShell = document.querySelector('#app-shell');
        try {
            const isBackendReady = yield (0, startup_1.pingBackend)(process.env.API_BASE_URL);
            if (!isBackendReady) {
                throw new Error('Backend ping returned a non-2xx response.');
            }
            startupState.hidden = true;
            appShell.hidden = false;
            initializeApplication();
        }
        catch (startupFailure) {
            console.error('Backend startup ping failed: ', startupFailure);
            spinner.hidden = true;
            error.hidden = false;
        }
    });
}
exports.startApplication = startApplication;
window.onload = function () {
    void startApplication();
};
